import bookKeeping from './book_keeping';
import bookmark from './bookmark';
import calendar from './calendar';
import catalogue from './catalogue';
import company from './company';
import documents from './documents';
import help from './help';
import home from './home';
import message from './message';
import MLDocument from './ml_document';
import PDF from './pdf';
import purchases from './purchases';
import receipt from './receipt';
import report from './report';
import settings from './settings';
import team from './team';
import user from './user';
import ZIP from './zip';

export default {
    bookKeeping,
    bookmark,
    calendar,
    catalogue,
    company,
    documents,
    help,
    home,
    message,
    MLDocument,
    PDF,
    purchases,
    receipt,
    report,
    settings,
    team,
    user,
    ZIP,
};
